var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "#AEB2BE",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6837 7.40402C13.5507 7.37078 13.4177 7.40402 13.3013 7.48714C12.8691 7.85286 12.3704 8.15208 11.8218 8.35156C11.3065 8.55104 10.7413 8.65078 10.1429 8.65078C8.79638 8.65078 7.56624 8.10221 6.6852 7.22117C5.80416 6.34013 5.25559 5.10999 5.25559 3.7635C5.25559 3.1983 5.35533 2.64973 5.52157 2.15103C5.70442 1.61908 5.9704 1.137 6.31949 0.721415C6.4691 0.538557 6.43585 0.272583 6.253 0.122972C6.13663 0.0398552 6.00364 0.00660835 5.87066 0.0398552C4.45767 0.422193 3.22754 1.26999 2.3465 2.40038C1.4987 3.51415 1 4.89389 1 6.39C1 8.20195 1.73143 9.84766 2.92831 11.0445C4.1252 12.2414 5.75429 12.9729 7.58287 12.9729C9.11222 12.9729 10.5252 12.4409 11.6556 11.5599C12.8026 10.6622 13.6338 9.38221 13.9829 7.91935C14.0494 7.68662 13.9164 7.45389 13.6837 7.40402Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(1)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/moon.3132a29e8962cefb2212ba0487a4dfbd.svg";